import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=2b320b1b&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"
import style0 from "./Logs.vue?vue&type=style&index=0&id=2b320b1b&prod&scoped=true&lang=css"
import style1 from "./Logs.vue?vue&type=style&index=1&id=2b320b1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b320b1b",
  null
  
)

export default component.exports